import { queryClient } from '@frontend/sorghum/external-providers';
import { ResponseWithData } from '@frontend/sorghum/interface';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { COMMENT_REPLY_DUPLICATE } from '../apis';

// 後端 40001 = 原名稱加 " copy" 後超過標題字數上限，整筆複製不執行
export const DUPLICATE_NAME_EXCEED_LIMIT_CODE = 40001;

interface DuplicateCommentReplyData {
  id: string;
  name: string;
}

async function postCommentReplyDuplicate(
  id: string,
): Promise<ResponseWithData<DuplicateCommentReplyData>> {
  return axios
    .post(COMMENT_REPLY_DUPLICATE, { id })
    .then((res) => res.data)
    .catch((err) => ({
      code: 400,
      msg: err,
    }));
}

export function usePostCommentReplyDuplicate() {
  return useMutation({
    mutationKey: ['post-comment-reply-duplicate'],
    mutationFn: (id: string) => postCommentReplyDuplicate(id),
    onSuccess: (data) => {
      // 複製後停留在列表頁（不像建立流程會導頁），必須主動 invalidate 新複本才會出現
      if (data.code === 20000) {
        queryClient.invalidateQueries({
          queryKey: ['get-comment-reply-list'],
        });
      }
    },
  });
}

export default usePostCommentReplyDuplicate;
